import Image from 'next/image'
import Section from 'components/common/Section'
import { SectionHeader } from 'components/marketing/SectionHeader'
import ExternalIcon from 'icons/ExternalIcon'
import { ComponentImageOverlappingBackground } from 'types/generated/contentful'
import { useThemeColor } from './ThemeContext'

export const ImageOverlappingBackground = ({
  label,
  headline,
  subheadline,
  linkLabel,
  linkUrl,
  image,
}: ComponentImageOverlappingBackground): JSX.Element => {
  const themeColor = useThemeColor()

  return (
    <Section bgColor='darkgray' relative>
      <div className='absolute inset-x-0 bottom-0 h-1/4 bg-white lg:h-1/3' />

      <SectionHeader
        label={label!}
        title={headline!}
        subline={subheadline!}
        highlight={themeColor}
        theme='dark'
      />

      {linkLabel && (
        <div className='-mt-12 mb-10 sm:flex sm:justify-center lg:-mt-24 lg:mb-14'>
          <a
            href={linkUrl!}
            target='_blank'
            rel='noopener noreferrer'
            className='inline-flex items-center gap-2 text-18 font-demibold text-neutral-on-dark-80 hover:text-neutral-on-dark'
          >
            {linkLabel}
            <ExternalIcon />
          </a>
        </div>
      )}

      <div className='max-w-screen-lg mx-auto relative'>
        <Image
          src={image!.url!}
          alt={image!.title!}
          width={image!.width!}
          height={image!.height!}
        />
      </div>
    </Section>
  )
}
